import Login from "./Login";
const Logout = () => {
    localStorage.removeItem("isLoggedIn");
    // Redirect to login page
    window.location.href = "https://classroombucket-v1.onrender.com/";
};

export default Logout;
